import { Link } from '@buoyhealth/common.buoy-button';
import { isWeekend } from '../utils';

const DoctorConfirmationConfirmation = () => {
  const itsTheWeekend = isWeekend();
  return (
    <div className="bp-font-primary-main bp-text-gray-100">
      <p>
        Thank you! We’ve sent your visit transcript to our clinical team. You’ll receive an email
        with your results {itsTheWeekend ? 'by Monday' : 'within 24 hours'}, during typical business
        hours.
      </p>
      <p className="bp-mt-4">
        If you have any questions you can reach us at{' '}
        <Link href="mailto:contact@buoyhealth.com">contact@buoyhealth.com</Link>.
      </p>
    </div>
  );
};

export default DoctorConfirmationConfirmation;
